/** CSS variable tokens for capability chips / timeline (shared by inspector + marketing embeds). */
export const INSPECTOR_CAPABILITY_COLORS: Record<string, string> = {
  fetch: 'var(--flux-fetch)',
  console: 'var(--flux-console)',
  env: 'var(--flux-env)',
  vm: 'var(--flux-vm)',
  time: 'var(--flux-time)',
  crypto: 'var(--flux-crypto)',
  math: 'var(--flux-math)',
  checkpoint: 'var(--flux-checkpoint)',
  timer: 'var(--flux-timer)',
  abort: 'var(--flux-abort)',
};
